/* ZOR — "Added to bag" confirmation.
   window.ZorBag.add(items) posts to /cart/add.js, refreshes the header count
   and opens the dialog from snippets/zor-added-sheet.liquid. `items` is an
   array of { id, quantity } or a FormData from a product form. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dlg, lastFocus;
  var shown = [];   // items listed while the sheet stays open
  var pairData = null;

  function el() { return dlg || (dlg = document.querySelector('[data-zor-added]')); }

  function money(cents) {
    var fmt = (el() && el().getAttribute('data-money-format')) || '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, fmt);
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt.replace(/\{\{\s*amount[^}]*\}\}/, n);
    return out !== fmt ? out : n;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function paintCount(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!count) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      icon.appendChild(bubble);
    }
    bubble.innerHTML = (count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
      '<span class="visually-hidden">' + count + (count === 1 ? ' item' : ' items') + '</span>';
  }

  function render(added, cart, append) {
    var d = el();
    if (!d) return;
    shown = append && d.open ? shown.concat(added) : added.slice();
    d.querySelector('[data-zor-added-items]').innerHTML = shown.map(function (it) {
      var meta = [];
      if (it.variant_title) meta.push(esc(it.variant_title.replace(/ \/ /g, ' \u00b7 ')));
      if (it.quantity > 1) meta.push('Qty ' + it.quantity);
      return '<li class="zor-added__item">' +
        (it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" width="72" height="96" loading="eager">' : '<span></span>') +
        '<div><p class="zor-added__name">' + esc(it.product_title) + '</p>' +
        (meta.length ? '<p class="zor-added__meta">' + meta.join(' \u00b7 ') + '</p>' : '') + '</div>' +
        '<span class="zor-added__price">' + money(it.final_line_price) + '</span></li>';
    }).join('');

    var threshold = parseInt(d.getAttribute('data-free-threshold'), 10) || 0;
    var total = cart.total_price;
    var ship = d.querySelector('[data-zor-added-ship]');
    var text = d.querySelector('[data-zor-added-ship-text]');
    var bar = d.querySelector('[data-zor-added-bar]');
    if (threshold) {
      ship.hidden = false;
      text.innerHTML = total >= threshold
        ? 'You\u2019ve unlocked <strong>free delivery</strong>.'
        : 'Add <strong>' + money(threshold - total) + '</strong> more for <strong>free delivery</strong>.';
      bar.style.width = '0';
      requestAnimationFrame(function () { bar.style.width = Math.min(100, (total / threshold) * 100) + '%'; });
    } else {
      ship.hidden = true;
    }

    d.querySelector('[data-zor-added-count]').textContent = cart.item_count + (cart.item_count === 1 ? ' item in your bag' : ' items in your bag');
    d.querySelector('[data-zor-added-subtotal]').textContent = money(total);
    renderPair(cart);
  }

  /* ---------- "Pairs well with" (Complete-the-Look product from the PDP) ---------- */
  function renderPair(cart) {
    var d = el();
    var box = d && d.querySelector('[data-zor-added-pair]');
    if (!box) return;
    var p = pairData;
    var inBag = p && (cart.items || []).some(function (it) {
      return p.variants.some(function (v) { return v.id === it.variant_id; });
    });
    var avail = p ? p.variants.filter(function (v) { return v.available; }) : [];
    if (!p || inBag || !avail.length) { box.hidden = true; box.innerHTML = ''; return; }

    var single = p.variants.length === 1;
    box.hidden = false;
    box.innerHTML =
      '<p class="zor-added__pair-h">Pairs well with</p>' +
      '<div class="zor-added__pair-card">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="" width="56" height="75" loading="lazy"></a>' +
        '<div class="zor-added__pair-info">' +
          '<a class="zor-added__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<p class="zor-added__meta">' + money(p.price) + '</p>' +
          (single ? '' : '<div class="zor-added__pair-sizes" role="group" aria-label="Choose size">' +
            p.variants.map(function (v) {
              return '<button type="button" data-pair-variant="' + v.id + '"' + (v.available ? '' : ' disabled') +
                ' aria-pressed="false">' + esc(v.label) + '</button>';
            }).join('') + '</div>') +
        '</div>' +
        '<button type="button" class="zor-added__pair-add" data-pair-add>Add</button>' +
      '</div>' +
      '<p class="zor-added__pair-err" data-pair-err hidden></p>';

    var chosen = single ? p.variants[0].id : null;
    var sizes = box.querySelector('.zor-added__pair-sizes');
    box.querySelectorAll('[data-pair-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        chosen = parseInt(b.getAttribute('data-pair-variant'), 10);
        box.querySelectorAll('[data-pair-variant]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (sizes) sizes.classList.remove('is-missing');
      });
    });
    var addBtn = box.querySelector('[data-pair-add]');
    var err = box.querySelector('[data-pair-err]');
    addBtn.addEventListener('click', function () {
      if (!chosen) {
        if (sizes) { sizes.classList.remove('is-missing'); void sizes.offsetWidth; sizes.classList.add('is-missing'); }
        err.textContent = 'Choose a size first';
        err.hidden = false;
        return;
      }
      addBtn.disabled = true;
      addBtn.textContent = 'Adding\u2026';
      err.hidden = true;
      add([{ id: chosen, quantity: 1 }], { append: true, keepPair: true }).catch(function (e) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add';
        err.textContent = e.userMessage || 'Could not add. Please try again.';
        err.hidden = false;
      });
    });
  }

  function open() {
    var d = el();
    if (!d) return;
    if (d.open) return;
    lastFocus = document.activeElement;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    document.body.classList.add('zor-added-lock');
    var cta = d.querySelector('.zor-added__checkout');
    if (cta) cta.focus();
  }

  function close() {
    var d = el();
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open');
  }

  function onClosed() {
    document.body.classList.remove('zor-added-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(payload, opts) {
    opts = opts || {};
    if (!opts.keepPair) pairData = opts.pair || null;
    var isForm = typeof FormData !== 'undefined' && payload instanceof FormData;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? payload : JSON.stringify({ items: payload })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) {
            var err = new Error(j.description || j.message || 'Could not add to bag');
            err.userMessage = j.description || j.message;
            throw err;
          }
          return j;
        });
      })
      .then(function (added) {
        var list = added.items || [added];
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            paintCount(cart.item_count);
            if (el()) { render(list, cart, opts.append); open(); }
            else { window.location.href = root + 'cart'; }
            document.dispatchEvent(new CustomEvent('zor:cart-added', { detail: { items: list, cart: cart } }));
            return cart;
          });
      });
  }

  function bind() {
    var d = el();
    if (!d || d.dataset.bound) return;
    d.dataset.bound = '1';
    d.addEventListener('close', onClosed);
    d.querySelectorAll('[data-zor-added-close]').forEach(function (b) { b.addEventListener('click', close); });
    // click on the backdrop (outside the panel) closes
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
  }

  window.ZorBag = { add: add, open: open, close: close };
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
})();
